import { Component, ViewChild, forwardRef, HostListener, ElementRef } from '@angular/core';
import { EventsService, EventType, EventFilterDate, EventFilter, CommissionService } from '../../services';
import { Commission } from "../../models";
import { AgentUtility } from '../../util';
import { Router } from '@angular/router';

import { EventComponent } from "../events/events.component";
import { CalendarEvent } from 'angular-calendar';
import { CalendarMonthViewDay } from 'angular-calendar';
import { DAYS_OF_WEEK } from 'angular-calendar';
import { EventInfoComponent } from "../event_info/event_info.component";
import { Subject } from "rxjs/Subject";
import { StringUtility } from 'app/util/string.utility';
import { MeetingsService } from '../../services/meetings.service';
import { AgentsService } from "../../services/agents.service";
import { AppComponent } from "../../app.component";


enum TypeView {
    ListView,
    CalendarView
}

@Component({
    moduleId: module.id,
    selector: 'workplace',
    templateUrl: './workplace.component.html',
    providers: [EventsService, CommissionService, MeetingsService]
})
export class WorkPlaceComponent {

    // Для календаря
    viewDate: Date = new Date();
    clickedDay: Date;
    view: string = 'month';
    refresh: Subject<any> = new Subject<any>();
    eventsCalendar: CalendarEvent[] = [];
    eventLocal: any[] = [];
    weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
    @ViewChild('eventInfo',{static: false}) eventInfo: EventInfoComponent;

    public selectedEventPeriod: EventFilterDate = EventFilterDate.Weekly;
    public eventFilterDate = EventFilterDate;
    private _eventFilter: EventFilter = new EventFilter();
    public events: any = [];
    public meetings:any = [];
    //public eventsChart: any = [];
    public eventTypes: any[];
    public isEven: boolean;
    public chartRadius: number;
    public _typeView = TypeView;
    public typeView: number = this._typeView.ListView;
    public prepData: any = {
        countEventTodo: '',
        countEventDone: '',
        percentEventDone: '',
        countToday: 0,
        countWeek: 0,
        countMonth: 0,
        countYear: 0
    };
    public commissions: Commission[] = [];

    // должен ли отображаться виджет геймификации
    public isWidgetShown = false;

    @ViewChild(forwardRef(() => EventComponent),{static: true}) private eventComponent: EventComponent;

    constructor(private _eventsService: EventsService, private router: Router, private eRef: ElementRef, private _commissionService: CommissionService,
    private _meetingsService:MeetingsService, private agentService: AgentsService, private appComponent: AppComponent ) {
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {

        } else {
            if (event.srcElement.pathname == '/') {
                this.selectedEventPeriod = this.eventFilterDate.Weekly;
                this.ngOnInit();
            }

        }
    }

    // @HostListener('window:resize', ['$event'])
    // onResize(event){
    //    location.reload(true);
    // }

    ngOnInit() {
        /// Фикс проверки логина на дашборде временнный
        let agentId = AgentUtility.getUser().Id;
        
        // this._eventFilter = { AgentId: agentId, page: 1, limit: 1000, typeDate: EventFilterDate.Weekly, excel: false };

        this._eventFilter = new EventFilter();
        this._eventFilter.AgentId = agentId;
        this._eventFilter.page = 1;
        this._eventFilter.limit = 1000;
        this._eventFilter.typeDate = EventFilterDate.Weekly;
        this._eventFilter.excel = false;

        this.bindEvents();
        this.rebindChart();

        this._commissionService
            .getCommission()
            .subscribe(data => {
                this.commissions = data.data;
            });
        //this.appComponent.checkMeetings();
        this.initWidgets();
    }


    public onContactSelected(event) {
        if (event.contracts.length > 0) {
            this._eventFilter.ContractIds = event.contracts;
        } else {
            this._eventFilter.ContractIds = null;
        }
        this.bindEvents();
    }

    public initWidgets() {
        const isGamification = AgentUtility.getUser().IsGamification;
        this.isWidgetShown = isGamification;

        if (isGamification === true) {
            this.addWidgetToPage('rating', 'widget-rating', 'info');
            this.addWidgetToPage('achievements', 'widget-achievements', 'info');
            this.addWidgetToPage('shop', 'widget-shop', 'module', 654, 400);
            this.addWidgetToPage('tasks', 'widget-tasks', 'module', 522, 300);
        }
    }

    public addWidgetToPage = (name: string, container: string, type: string, width?: number, height?: number, limit?: number) => {
        const script = StringUtility.getGamificationScript(name, container, type, width, height, limit);
        if (script) {
            this.eRef.nativeElement.appendChild(script);
        }
    }

    public onRatingClick() {
        this.router.navigateByUrl('rating-full');
    }

    public onAchievementClick() {
        this.router.navigateByUrl('achievements-full');
    }

    public onApplicationsNewClick() {
        this.router.navigateByUrl('applications/new');
    }

    public onShopFullClick() {
        this.router.navigateByUrl('shop-full');
    }

    public onTasksFullClick() {
        this.router.navigateByUrl('tasks-full');
    }

    public onChartClick(typeId) {
        if(typeId == 6)
            return;
            
        localStorage.setItem('filterContracts', JSON.stringify({ eventTypeId: typeId }));
        this.router.navigateByUrl('events');
    }

    // Если отметили событие как завершенное.
    public onChangeEventState() {
        this.bindEvents();
        this.rebindChart();
    }

    public onChangeEventPeriod(eventPeriodType: EventFilterDate) {
        switch (eventPeriodType) {
            case EventFilterDate.Today:
                this._eventFilter.typeDate = (this.selectedEventPeriod = EventFilterDate.Today);
                break;
            case EventFilterDate.Weekly:
                this._eventFilter.typeDate = (this.selectedEventPeriod = EventFilterDate.Weekly);
                break;
            case EventFilterDate.Month:
                this._eventFilter.typeDate = (this.selectedEventPeriod = EventFilterDate.Month);
                break;
            case EventFilterDate.Year:
                this._eventFilter.typeDate = (this.selectedEventPeriod = EventFilterDate.Year);
                break;
        }
        this.bindEvents();
        this.eventComponent.bindEventsMeetings(this._eventFilter);
        this.rebindChart();
    }

    public getCountEventsByType(typeId): any {
        // if (!this.events) return [];
        if(typeId == 6)
            return this.meetings.filter(item => !item.Result).length;
        else
            return this.events.filter((item) => {
                return item.EventTypeId == typeId && item.IsViewed == false;
            }).length;
    }

    public getCountEventsByTypeD(typeId): any {
        // if (!this.events) return [];
        if(typeId == 6)
            return this.meetings.filter(item => item.Result).length;
        else
            return this.events.filter((item) => {
                return item.EventTypeId == typeId && item.IsViewed == true;
            }).length;
    }

    // Передаем фильтр для списка событий.
    private bindEvents() {
        this._eventFilter.deep = true;
        this.eventComponent.bind(this._eventFilter);
        //this.eventComponent.bindLocal(this.events);
    }

    

    

    private rebindChart() {
        this._eventFilter.limit = 1000;
        let agent = AgentUtility.getUser();
        this._eventFilter.AgentId = agent.Id;
        this._eventsService.getEvents(this._eventFilter)
            .subscribe((data) => {
                if (data.data == undefined) {
                    //this.router.navigateByUrl('/signin');
                }
                this.events = data.data || [];
                this.rebindEvents();
            });
        this.agentService.getAgent(this._eventFilter.AgentId).subscribe(data => {
            let dataAgent = data.data;
            if(dataAgent != undefined){
                this._eventFilter.AgentId = dataAgent.ContactId;
            }
            this._eventFilter.page = 0; //getMeetingsByFilterDate //getMeetingsByFilterLink
            this._meetingsService.getMeetingsByFilterLink(this._eventFilter).subscribe(data => {
                this.meetings = data.data[0];

                if(this._eventFilter.typeDate == 0){
                    var seventhDay = new Date();
                    seventhDay.setDate(seventhDay.getDate());
                    this.meetings = this.meetings.filter((meeting) => {
                        return new Date(meeting.Date).getDate() == seventhDay.getDate() && new Date(meeting.Date).getMonth() + 1 == seventhDay.getMonth() + 1
                    })
                }
                if(this._eventFilter.typeDate == 1){ //
                    var seventhDay = new Date();
                    var seventhDay2 = new Date();
                    seventhDay.setDate(seventhDay.getDate() + 7);
                    seventhDay2.setDate(seventhDay2.getDate() - 1);
                    
                    this.meetings = this.meetings.filter((meeting) => {
                        return new Date(meeting.Date).getTime() <= seventhDay.getTime() && new Date(meeting.Date).getTime() >= seventhDay2.getTime()
                    })
                }
                // if(this._eventFilter.typeDate == 2){
                //     var seventhDay = new Date();
                //     //seventhDay.setDate(seventhDay.getMonth());
                //     this.meetings = this.meetings.filter((meeting) => {
                //         return new Date(meeting.Date).getMonth() + 1 == seventhDay.getMonth() + 1
                //     })
                // }
                //this.meetings = this.meetings.filter(date => date.date )
                this.rebindEvents();
            });
        });

        this._eventsService.getTypesList()
            .subscribe((data) => {
                this.eventTypes = data.data;
                this.eventTypes.sort((x) => {
                    if (x.Name === "Очередной платёж")
                        return -1;
                    else
                        return 1;
                });
                this.isEven = this.eventTypes.length % 2 == 0;
                this.chartRadius = this.isEven ? 50 : 60;
                if (window.innerWidth <= 1200)
                    this.chartRadius = 50;
            });
    }

    public rebindEvents(){
        let bindEvents:any[] = this.events.map(x => {
            if (!x.IsViewed) {
                return {
                    title: x.EventType,
                    color: {},
                    start: new Date(x.EventDate),
                    meta: {
                        type: x.Color,
                        data: x
                    }
                };
            }
        }).filter(x => x != undefined);
        let bindMeetings:any[] = this.meetings.map(x => {
            return {
                title: "Встреча",
                color: {},
                start: new Date(x.Date),
                meta:{
                    type:"#F5B81A",
                    data:x
                }
            }
        })
        this.eventsCalendar = bindEvents.concat(bindMeetings);

        this._eventsService.getPreparedData(this.eventsCalendar || [])
            .subscribe(data => {
                this.prepData = data;
            });
    }

    /** Веренет текущий год */
    public getCurrYear() {
        return new Date().getFullYear();
    }

    /** Вернет сумму вознаграждений за год. */
    public getRewardSum(): number {
        return this.commissions
            .map(c => c.CommissionAmount)
            .reduce<number>((a, b) => {
                return (+a) + (+b);
            }, 0);
    }

    beforeMonthViewRender({ body }: { body: CalendarMonthViewDay[] }): void {
        body.forEach(cell => {
            const groups: any = {};
            cell.events.forEach((event: CalendarEvent<{ type: string }>) => {
                groups[event.meta.type] = groups[event.meta.type] || [];
                groups[event.meta.type].push(event);
            });
            cell['eventGroups'] = Object.entries(groups);
        });
    }

    log(obj) {
        
    }

    bindCalendarInfo(event) {
        this.clickedDay = event.day.date;
        this.refresh.next();
        this.eventLocal = event.day.events.map(e => e.meta.data);
        this.eventInfo.rebindLocal(this.eventLocal);
    }
}